var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.310547,
    y: 0.625,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E7EFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8584 10.625H17.7626C15.8593 10.625 14.3105 12.1738 14.3105 14.0771V14.625H13.7626C11.8593 14.625 10.3105 16.1738 10.3105 18.0771V27.1728C10.3105 29.0762 11.8593 30.625 13.7626 30.625H22.8583C24.6068 30.625 26.0405 29.3132 26.2647 27.625H26.8583C28.7617 27.625 30.3105 26.0762 30.3105 24.1729V14.0771C30.3105 12.1738 28.7617 10.625 26.8584 10.625ZM28.3105 24.1729C28.3105 24.9736 27.6591 25.625 26.8584 25.625H26.3105V18.0771C26.3105 16.1738 24.7617 14.625 22.8584 14.625H16.3105V14.0771C16.3105 13.2764 16.9619 12.625 17.7626 12.625H26.8583C27.6591 12.625 28.3105 13.2764 28.3105 14.0771V24.1729Z",
    fill: "#123051"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.db224d6765d5650bb439fe60be282045.svg";
export { ForwardRef as ReactComponent };